import { Attr, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";

@Model()
class PartnerTeamMemberRequest extends ApplicationRecord {
  static jsonapiType = "partner_team_member_requests";

  @Attr() email: string;

  @Attr() firstName: string;

  @Attr() lastName: string;

  @Attr() admin: boolean;
}

export default PartnerTeamMemberRequest;
